/**
 * @desc This service encapsulates getting remediation policy violations and exposes them via a getter
 */
;(function () {
  'use strict'

  angular
    .module('contrast.vulnerabilities.violations')
    .factory(
      'csVulnerabilityViolationsService',
      csVulnerabilityViolationsServiceFactory
    )

  function csVulnerabilityViolationsServiceFactory(
    orgTraceApiConfig,
    ServiceUtils
  ) {
    'ngInject'

    var _violations
    var _count = 0

    return {
      getViolations: getViolations,
      getCount: getCount
    }

    function getCount() {
      return _count
    }

    function getViolations() {
      return orgTraceApiConfig
        .getRemediationPolicyViolations()
        .then(function (response) {
          _violations = response.data.traces
          _count = _violations.length
          return _violations
        })
        .catch(ServiceUtils.handleError)
    }
  }
})()
